(function () {

    function init() {
      $('body').addClass('fe-470-remove-saudi-zip')
   }

    window.feUtils.waitForConditions({
        conditions: ['body #getQuoteForm'],
        activity: feProjectId,
        callback: init
    });
})();
